import {Component} from '@packages/systems/wfdl';
import {type NativeId} from '@packages/systems/core/utils/NativeIdUtils';
import type {NodeClickedPayload} from './types';

import {mem_transformDesignerPayload} from '../shared/transformPayload';

export const transformNodeClickedPayload = (
  payload: NodeClickedPayload,
  components: Component.ComponentMap,
  focusedSymbolNativeIdPath: NativeId[]
): NodeClickedPayload => {
  return mem_transformDesignerPayload<NodeClickedPayload>(payload)(components)(
    focusedSymbolNativeIdPath
  );
};
